
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trail-series/specs",
      function () {
        return require("private-next-pages/trail-series/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trail-series/specs"])
      });
    }
  